import { compact } from "lodash";
import { classNames } from "primereact/utils";
import { Ref } from "react";
import { useTranslation } from "react-i18next";
import { setTruncatedTitle } from "../../../../../common/utils";
import type { PanelTreeNode } from "./PanelTemplate";

interface LocationOptionTemplateProps {
    isSelected: boolean;
    location: PanelTreeNode;
    ref: Ref<HTMLDivElement> | null;
    onSelect: () => void;
}

const LocationOptionTemplate = (props: LocationOptionTemplateProps) => {
    const { isSelected, location, ref, onSelect } = props;

    const { t } = useTranslation(["common", "setUpSpaces"]);

    const description = compact([
        location.city,
        location.locationType &&
            t(`setUpSpaces:locationType.${location.locationType}`),
    ]).join(" · ");

    return (
        <div
            ref={ref}
            className={classNames(
                "flex items-center gap-2.5 rounded-md px-2.5 py-2 cursor-pointer hover:bg-surface-515 transition-colors duration-150",
                { "bg-primary-50!": isSelected }
            )}
            onClick={onSelect}
        >
            <div
                className={classNames(
                    "flex size-6.5 shrink-0 items-center justify-center rounded-md",
                    isSelected
                        ? "bg-primary-500 text-primary-text"
                        : "bg-primary-50 text-primary-600"
                )}
            >
                <i className="pi pi-map-marker text-xs" />
            </div>
            <div className="flex min-w-0 grow flex-col">
                <span
                    className={classNames(
                        "truncate",
                        isSelected
                            ? "font-semibold text-primary-700"
                            : "font-medium"
                    )}
                    onMouseEnter={setTruncatedTitle}
                >
                    {location.name}
                </span>
                {description && (
                    <span className="truncate text-xs text-text-300">
                        {description}
                    </span>
                )}
            </div>
        </div>
    );
};

export default LocationOptionTemplate;
